export default {
	consumption: {
		consumptionInformation: 'Verbrauchsinformationen',
		heating: 'Heizung',
		hot_water: 'Warmwasser',
		name: 'Verbrauch',
		kwh: 'kWh',
		estimated_costs: 'geschätzte Kosten',
		emissions: 'Emissionen',
		efficiency: 'Effizienz',
		consumption_per_sqm: 'Verbrauch pro qm',
		limit_value: 'Grenzwert',
		monthly: 'monatlich',
		yearly: 'jährlich',
		consumption_kwh: 'Verbrauch in kWh',
		emissions_grams_co2: 'Emissionen in Gramm CO2',
		costs_euro: 'Kosten in Euro',
	},
}
